export default __webpack_public_path__ + "static/media/HobbyConnectAppLogo.d63cdf20.png";